import { Credentials, wchGetCredentials } from '@ibm-wch-sdk/cli-credentials';
import { from, Observable } from 'rxjs';

export function wchToolsGetCredentials(
  aApiUrl: string
): Observable<Credentials> {
  // return
  return from(wchGetCredentials(aApiUrl));
}
